import styled, { css } from 'styled-components';

import { Box } from '@/components/Box';
import { Button } from '@/components/Button';
import { Flex } from '@/components/Flex';
import { Grid } from '@/components/Grid';
import { PaymentRecords as OriginPaymentRecords } from '@/views/PaymentView/components/PaymentRecords/PaymentRecords';

import { ReactComponent as Reminder } from '@/assets/icons/reminder-icon.svg';

export const OrderLineRow = styled(Flex)`
  ${({ theme }) => css`
    border-bottom: 1px solid ${theme.colors.mediumGrey};
    ${theme.media.md.down} {
      flex-wrap: wrap;
    }
  `}
`;

export const ImageWrapper = styled.div`
  min-width: 80px;
  width: 80px;
  height: 120px;
  position: relative;
  margin-right: 33px;
`;

export const OrderProductImageInfo = styled(Flex)`
  width: 50%;
`;
export const OrderProductReturnInfo = styled(Flex)`
  width: 20%;
  ${({ theme }) => css`
    justify-content: end;

    ${theme.media.md.up} {
      justify-content: start;
    }
  `}
`;

export const StyledGrid = styled(Grid)`
  align-content: center;
`;

export const StyledLink = styled.a`
  ${({ theme }) => css`
    font-size: ${theme.fontSizes.p2};
  `}
`;

export const PriceWrap = styled(Box)`
  width: 20%;
  align-content: center;
  ${({ theme }) => css`
    ${theme.media.md.down} {
      display: flex;
      flex-direction: column;
      width: 100%;
      margin-bottom: ${theme.space[2]};
    }
  `}
`;

export const OrderDetailHeader = styled(Box)`
  display: flex;
  justify-content: space-between;
  margin-bottom: 1rem;
`;

export const StatusButton = styled(Box)`
  display: flex;
  justify-content: center;
  align-items: center;
  text-transform: uppercase;
  ${({ theme }) => css`
    color: ${theme.colors.white};
    height: 1.5rem;
    padding: 0px ${theme.space[1]};
    gap: ${theme.space[1]};
    background: #072c54;
    font-family: ${theme.fontFamilies.openSans};
    font-size: ${theme.fontSizes.p3};
    font-weight: ${theme.fontWeights.bold};
    ${theme.media.md.down} {
      display: inline-flex;
    }
  `}
`;

export const OrderLineReturnInfoWrap = styled(Box)`
  ${({ theme }) => css`
    ${theme.media.md.down} {
      display: inline-flex;
      flex-direction: column;
    }
  `}
`;

export const Link = styled(Box)`
  display: inline-block;
  cursor: pointer;
  height: 1.5rem;
  text-align: center;
  ${({ theme }) => css`
    font-size: ${theme.fontSizes.p2};
    font-family: ${theme.fontFamilies.openSans};
    font-weight: ${theme.fontWeights.regular};
    border-bottom: 1px solid ${theme.colors.primary};
  `}
  .text {
    color: #072c54;
    line-height: 22px; /* 157.143% */
    &:hover {
      color: ${({ theme }) => theme.colors.primary};
    }
  }
`;

export const ReminderBox = styled(Box)`
  padding: 12px;
`;

export const BalanceButton = styled(Button)`
  width: 100%;
`;

export const ReminderIcon = styled(Reminder)`
  min-width: 30px;
`;

export const PaymentRecords = styled(OriginPaymentRecords)`
  && {
    padding: 0;
  }
`;
